import React, { FC } from 'react'
import { businessSupportStrings } from 'common/strings/business-support-strings'
import classNames from 'classnames'
import useWindowSize from 'components/util/useWindowSize'
import imageResize from 'project/image-proxy-web' // we need this to make JSX compile

type AddressSectionType = {}

type SectionType = {
  imageSource: string
  name: string
  jobTitle: string
  content: string
}
const relationships: [
  [SectionType, SectionType, SectionType],
  [SectionType, SectionType, SectionType],
] = [
  [
    {
      content:
        '“Working with the Hoxton Mix at both Unilever and Beiersdorf has been fantastic. It gave us access to some of the best start up talent. The service provided is excellent with the team expertly curating the proposed solutions to our business problems from their wide network in a cost effective manner.”',
      imageSource: require('public/images/company/relationships/joe-comiskey.png'),
      jobTitle: 'Head of Digital for Northern Europe at Beiersdorf',
      name: 'Joe Comiskey',
    },
    {
      content:
        "I've worked with The Hoxton Mix on a number of events which have always been executed to very high standards. I look forward to engaging with them again once the Level Up bursary programme launches. It's a fantastic initiative and will boost creativity and tech jobs in the local community.",
      imageSource: require('public/images/company/relationships/simon-devonshire.png'),
      jobTitle: 'Former Entrepreneur in Residence for Dept BEIS',
      name: 'Simon Devonshire',
    },
    {
      content:
        'The Hoxton Mix has been actively involved and instrumental in the growth of the London technology scene. They continue to foster innovation and entrepreneurship to drive growth in the sector.',
      imageSource: require('public/images/company/relationships/eric-van-der-kleij.png'),
      jobTitle: 'CEO, Frontiernetwork.com, Chairman of Keybox.co',
      name: 'Eric Van Der Kleij',
    },
  ],
  [
    {
      content:
        "I've worked with The Hoxton Mix on many tech events from hackathons to demo days and immersion sessions. They have always delivered excellent facilitation and engagement and the Level Up Bursary Programme is another way to ensure the community can get access to genuinely affordable space and services.",
      imageSource: require('public/images/company/relationships/benjamin-southworth.png'),
      jobTitle:
        'Founder, Southworth Industries /<br/> Former Deputy Chief Executive (TCIO)',
      name: 'Benjamin Southworth',
    },
    {
      content:
        'For over a decade, The Hoxton Mix has been a significant part of the London tech scene by fostering a strong startup ecosystem and helping entrepreneurs based in and around London start, run and grow their businesses.',
      imageSource: require('public/images/company/relationships/pru-ashby.png'),
      jobTitle: 'Head of North America - London & Partners',
      name: 'Pru Ashby',
    },
    {
      content:
        'The Hoxton Mix have been a mainstay of the tech ecosystem for a long time, offering meet ups, access to mentors and a huge level of support for local businesses. As well as this, they have been able to bring together these businesses with large multinationals to collaborate on all manner of exciting projects, helping create value for everyone involved.',
      imageSource: require('public/images/company/relationships/joe-scarboro.png'),
      jobTitle: 'Founder - 3 Beards / Entrepreneur',
      name: 'Joe Scarboro',
    },
  ],
]
const AddressSection: FC<AddressSectionType> = ({}) => {
  const size = useWindowSize()
  return (
    <div
      className={'bg-gradient-blue3 py-xxl-50 py-xl-38 py-lg-12 pt-12 pb-14'}
    >
      <div className='container'>
        <p
          className={'h4 h4--small text-center text-bold mb-lg-3 mb-6'}
          dangerouslySetInnerHTML={{
            __html: businessSupportStrings.helpingTheCommunity,
          }}
        />
        <h2
          className={classNames(
            'text-center text-bold mb-lg-13 mb-12',
            size.isLgOrHigher ? 'fs-fluid-36-80 lh-105' : 'h3',
          )}
        >
          {businessSupportStrings.relationships}
        </h2>
        <div className={'row text-white'}>
          {relationships.map((item, k) => (
            <div
              className={classNames('col-lg-5 px-lg-6 px-5', {
                'ms-auto': k % 2 != 0,
              })}
            >
              {item.map((v, i) => (
                <div
                  className={classNames(
                    k == 0 && i == 0 ? '' : 'mt-lg-39',
                    k == 1 && i == 2 ? '' : 'mb-lg-0 mb-14',
                  )}
                >
                  <img
                    loading='lazy'
                    className={'img-fluid'}
                    src={imageResize(v.imageSource)}
                    alt={`${v.name} photo`}
                  />
                  <h3
                    className={
                      'h2 h2--sm-on-desktop h2--lg-on-mobile text-bold mt-lg-3 mt-4'
                    }
                  >
                    {v.name}
                  </h3>
                  <h4
                    className={'text-large text-normal mb-6'}
                    dangerouslySetInnerHTML={{ __html: v.jobTitle }}
                  />
                  <p
                    className={classNames(
                      'lead lead--md lead--ls-lg-on-mobile mb-0',
                      k == 0 && i == 0
                        ? 'pe-lg-2 pe-6'
                        : k == 1 && i == 2
                        ? 'pe-lg-4 pe-6'
                        : 'pe-6',
                    )}
                  >
                    {v.content}
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AddressSection
